import { ToastContainer } from "react-toastify";
import Layout from "./components/Layout/Layout";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <Layout />
      <ToastContainer autoClose={2000} />
    </>
  );
}

export default App;
